/**
 * Runtime configuration, read from `/config.js` — never from an env var baked
 * into the bundle (02-requirements.md §Admin Deployment). `import.meta.env` is
 * frozen at build time, which is exactly what the requirement forbids: one
 * image has to run against a laptop, a LAN host and a server.
 */
export interface CampConfig {
  apiBaseUrl: string;
  /** OAuth Web client id for "Entrar com Google" — the API's GOOGLE_CLIENT_ID. */
  googleClientId: string | null;
}

declare global {
  interface Window {
    __CAMP_CONFIG__?: Partial<CampConfig>;
  }
}

const FALLBACK: CampConfig = { apiBaseUrl: '/api', googleClientId: null };

export function readConfig(): CampConfig {
  const raw = typeof window === 'undefined' ? undefined : window.__CAMP_CONFIG__;
  return {
    apiBaseUrl: raw?.apiBaseUrl ?? FALLBACK.apiBaseUrl,
    // An empty string is how the entrypoint writes "unset".
    googleClientId: raw?.googleClientId?.trim() || FALLBACK.googleClientId,
  };
}
